<script>
import SelectUI from "../ui/SelectUI.vue";
import RangeUI from "../ui/RangeUI.vue";
import DopFilter from "../ui/DopFilter.vue";
import darkBtn from "../ui/darkBtn.vue";
import MiniCardCompany from "../elements/MiniCardCompany.vue";

import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";


export default {
  name: "SearchEmployes",
  components: {
    Swiper,
    SwiperSlide,
    SelectUI,
    DopFilter,
    darkBtn,
    MiniCardCompany,
    RangeUI,
  },
  setup() {
    const swiperActiveIndex = 0; // начальный активный индекс
    const onSwiper = (swiper) => {
      console.log(swiper.activeIndex);
    };
    return {
      onSwiper,
      swiperActiveIndex,
      modules: [Navigation, Pagination, Scrollbar, A11y],
    };
  },
  data() {
    return {
      values: {
        min: 10000,
        max: 159600,
      },
      activeDistrict: [
        {
          id: 1,
          name: "Выберите район",
        },
      ],
      vacancies: [
        {
          id: 1,
          name: "Менеджер по продажам",
          description: "Описание вакансии",
        },
        {
          id: 2,
          name: "Повар-кондитер",
          description: "Описание вакансии",
        },
        {
          id: 3,
          name: "Product-designer",
          description: "Описание вакансии",
        },
        {
          id: 4,
          name: "Бухгалтер",
          description: "Описание вакансии",
        },
        {
          id: 5,
          name: "Налоговый консультант",
          description: "Описание вакансии",
        },
      ],
      kategoryes: [
        {
          id: 1,
          name: "Все категории",
        },
        {
          id: 2,
          name: "Junior",
        },
        {
          id: 3,
          name: "Middle",
        },
        {
          id: 4,
          name: "Senior",
        },
      ],
      specializations: [
        {
          id: 1,
          name: "Выберите специализацию",
        },
        {
          id: 2,
          name: "Front-end",
        },
        {
          id: 3,
          name: "Back-end",
        },
        {
          id: 4,
          name: "Full-stack",
        },
      ],
      regions: [
        {
          id: 1,
          name: "Выберите регион",
        },
        {
          id: 2,
          name: "Москва",
          district: [
            {
              id: 1,
              name: "Выберите район",
            },
            {
              id: 2,
              name: "Центр",
            },
            {
              id: 3,
              name: "Запад",
            },
            {
              id: 4,
              name: "Восток",
            },
          ],
        },
        {
          id: 3,
          name: "Санкт-Петербург",
          district: [
            {
              id: 1,
              name: "Выберите район",
            },
            {
              id: 2,
              name: "Центр",
            },
            {
              id: 3,
              name: "Запад",
            },
            {
              id: 4,
              name: "Восток",
            },
          ],
        },
        {
          id: 4,
          name: "Новосибирск",
          district: [
            {
              id: 1,
              name: "Выберите район",
            },
            {
              id: 2,
              name: "Центр",
            },
            {
              id: 3,
              name: "Запад",
            },
            {
              id: 4,
              name: "Восток",
            },
          ],
        },
        {
          id: 5,
          name: "Екатеринбург",
          district: [
            {
              id: 1,
              name: "Выберите район",
            },
            {
              id: 2,
              name: "Центр",
            },
            {
              id: 3,
              name: "Запад",
            },
            {
              id: 4,
              name: "Восток",
            },
          ],
        },
      ],
      experiences: [
        {
          id: 1,
          name: "Выберите опыт",
        },
        {
          id: 2,
          name: "Без опыта",
        },
        {
          id: 3,
          name: "От 1 года до 3 лет",
        },
        {
          id: 4,
          name: "От 3 до 6 лет",
        },
        {
          id: 5,
          name: "От 6 до 9 лет",
        },
        {
          id: 6,
          name: "От 9 лет и выше",
        },
      ],

      typesOfEmployment: [
        {
          id: 1,
          name: "Выберите тип занятости",
        },
        {
          id: 2,
          name: "Полная занятость",
        },
        {
          id: 3,
          name: "Частичная занятость",
        },
        {
          id: 4,
          name: "Проектная работа",
        },
        {
          id: 5,
          name: "Удаленная работа",
        },
      ],
      workSchedule: [
        {
          id: 1,
          name: "Выберите график",
        },
        {
          id: 2,
          name: "Полная занятость",
        },
        {
          id: 3,
          name: "Частичная занятость",
        },
        {
          id: 4,
          name: "Удаленная работа",
        },
      ],
      educations: [
        {
          id: 1,
          name: "Выберите образование",
        },
        {
          id: 2,
          name: "Высшее",
        },
        {
          id: 3,
          name: "Среднее",
        },
        {
          id: 4,
          name: "Среднее специальное",
        },
      ],
      ages: [
        {
          id: 1,
          name: "Выберите возраст",
        },
        {
          id: 2,
          name: "18-25",
        },
        {
          id: 3,
          name: "25-30",
        },
        {
          id: 4,
          name: "30-35",
        },
      ],
      dopFiltres: [
        {
          id: 1,
          name: "Рейтинг",
        },
        {
          id: 2,
          name: "Отзывы",
        },
        {
          id: 3,
          name: "Стоимость",
        },
        {
          id: 4,
          name: "Зарплата",
        },
        {
          id: 5,
          name: "Занятость",
        },
      ],
      company: {
        verified: true,
        rating: 9.7,
        name: "ПАО «Сбербанк»",
        logo: require("@/assets/image/logoSber.png"),
        subscriptions: "43.7k",
        vakancies: [
          {
            id: 1,
            infoVakanci: {
              experience: "3-5",
              solary: "180 000+",
              ransom: "130 000+",
              schedule: "Полный",
              name: "Product Designer",
            },
          },
          {
            id: 1,
            infoVakanci: {
              experience: "3-5",
              solary: "180 000+",
              ransom: "130 000+",
              schedule: "Полный",
              name: "Product Designer",
            },
          },
          {
            id: 1,
            infoVakanci: {
              experience: "3-5",
              solary: "180 000+",
              ransom: "130 000+",
              schedule: "Полный",
              name: "Product Designer",
            },
          },
          {
            id: 1,
            infoVakanci: {
              experience: "3-5",
              solary: "180 000+",
              ransom: "130 000+",
              schedule: "Полный",
              name: "Product Designer",
            },
          },
          {
            id: 1,
            infoVakanci: {
              experience: "3-5",
              solary: "180 000+",
              ransom: "130 000+",
              schedule: "Полный",
              name: "Product Designer",
            },
          },
        ],
      },
    };
  },
  methods: {
    toogleActive(id) {
      let tabs = document.querySelectorAll(".tabs__item");
      tabs.forEach((item) => {
        item.classList.remove("active");
      });
      document.getElementById(id).classList.add("active");
    },
    activeEl(id) {
      document.querySelector(id).classList.add("active");
    },
    removeEl(id) {
      document.querySelector(id).classList.remove("active");
    },
    sort(o) {
      this.activeDistrict = o.district;
    },
  },
};
</script>

<template>
  <div class="search_wrap">
    <div class="container">
      <div class="head">
        <div class="headComponent">
          <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
            <circle cx="19" cy="19" r="19" fill="#7700FF" />
            <path
              d="M11.9275 19.538L20.1153 20.6671C20.3614 20.701 20.6097 20.644 20.8056 20.5086C21.0016 20.3731 21.1291 20.1704 21.1602 19.9449L22.7629 8.32311C22.7882 8.13954 22.7481 7.95195 22.6484 7.78839C22.5487 7.62483 22.3949 7.49408 22.2099 7.4157C22.0249 7.33732 21.8186 7.31551 21.6221 7.35355C21.4255 7.39159 21.249 7.48742 21.1192 7.62672L11.3299 18.1186C11.2215 18.2344 11.1499 18.3757 11.1224 18.5276C11.095 18.6795 11.1128 18.8363 11.174 18.9816C11.2351 19.1269 11.3374 19.2553 11.47 19.3532C11.6026 19.4511 11.7606 19.5149 11.9275 19.538Z"
              fill="white" />
            <path
              d="M25.2103 20.4648L16.9807 19.3299C16.7404 19.2971 16.4981 19.3528 16.307 19.4848C16.1158 19.6169 15.9914 19.8144 15.9611 20.0341L14.3526 31.6988C14.3278 31.8776 14.367 32.0603 14.4643 32.2197C14.5615 32.3791 14.7117 32.5066 14.8922 32.583C15.0727 32.6594 15.274 32.6808 15.4658 32.6438C15.6577 32.6068 15.8298 32.5135 15.9565 32.3778C19.2368 28.8694 22.516 25.3608 25.7941 21.852C25.9008 21.7392 25.9714 21.6012 25.9987 21.4527C26.0259 21.3042 26.0087 21.1507 25.9489 21.0085C25.8891 20.8663 25.7888 20.7407 25.6588 20.645C25.5287 20.5493 25.3738 20.487 25.2103 20.4648Z"
              fill="white" />
          </svg>
          Вакансии
        </div>
        <a  class="link">Все категории</a>
      </div>
      <div class="mob wrap-search-btn">
        <div class="searchInput" :id="'searchInput'" @mouseover="activeEl('.body')" @mouseleave="removeEl('.body')">
          <input type="text" class="search_Input" placeholder="Введите запрос..." />
          <button class="searchBtn">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20Z"
                stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path opacity="0.4"
                d="M18.9299 20.6888C19.4599 22.2888 20.6699 22.4488 21.5999 21.0488C22.4499 19.7688 21.8899 18.7188 20.3499 18.7188C19.2099 18.7088 18.5699 19.5988 18.9299 20.6888Z"
                stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
        <darkBtn class="darkBtn">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z"
              stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path opacity="0.4" d="M6 8V16" stroke="white" stroke-width="1.5" stroke-miterlimit="10"
              stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9 8V12" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M9 15V16" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M15 8V9" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
              stroke-linejoin="round" />
            <path opacity="0.4" d="M12 8V16" stroke="white" stroke-width="1.5" stroke-miterlimit="10"
              stroke-linecap="round" stroke-linejoin="round" />
            <path d="M15 12V16" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
              stroke-linejoin="round" />
            <path opacity="0.4" d="M18 8V16" stroke="white" stroke-width="1.5" stroke-miterlimit="10"
              stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          Аукционы
        </darkBtn>
      </div>
      <div class="wrap-swiper-btns">
        <div class="btns">
          <a  class="btn-setting">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.334 5.41699H13.334" stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <g opacity="0.4">
                <path d="M4.99935 5.41699H1.66602" stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M8.33268 8.33333C9.94351 8.33333 11.2493 7.0275 11.2493 5.41667C11.2493 3.80584 9.94351 2.5 8.33268 2.5C6.72185 2.5 5.41602 3.80584 5.41602 5.41667C5.41602 7.0275 6.72185 8.33333 8.33268 8.33333Z"
                  stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                  stroke-linejoin="round" />
              </g>
              <path d="M6.66602 14.583H1.66602" stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <g opacity="0.4">
                <path d="M18.3333 14.584H15" stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M11.6667 17.5003C13.2775 17.5003 14.5833 16.1945 14.5833 14.5837C14.5833 12.9728 13.2775 11.667 11.6667 11.667C10.0558 11.667 8.75 12.9728 8.75 14.5837C8.75 16.1945 10.0558 17.5003 11.6667 17.5003Z"
                  stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                  stroke-linejoin="round" />
              </g>
            </svg>
          </a>
          <a  class="btn-sort">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.50755 17.0832L3.32422 12.9082" stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path d="M7.50781 2.91699V17.0837" stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <g opacity="0.4">
                <path d="M12.4922 2.91699L16.6755 7.09199" stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.4922 17.0837V2.91699" stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round" />
              </g>
            </svg>
          </a>
        </div>
        <swiper :slidesPerView="'auto'" :loop="true" :modules="modules" class="tabs__vakancies">
          <swiper-slide @click="toogleActive('tab' + item.id)" class="tabs__item" v-for="item in vacancies"
            :key="item.id" :id="'tab' + item.id">
            {{ item.name }}
          </swiper-slide>
        </swiper>
      </div>
      <div class="kategoryes">
        <div class="link__filteres">
          <SelectUI :options="specializations" />
          <SelectUI :options="regions" @sort="sort" />
          <SelectUI :options="activeDistrict" />
          <SelectUI :options="experiences" />
          <SelectUI :options="typesOfEmployment" />
          <SelectUI :options="workSchedule" />
          <RangeUI :values="values" />
        </div>
      </div>
      <div class="head head-result">
        <div class="headComponent">
          <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="19" cy="19" r="19" fill="#7700FF" />
            <path opacity="0.34" d="M24.3733 12.6836C26.54 14.1894 28.035 16.5836 28.3383 19.3461" stroke="white"
              stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path opacity="0.34" d="M9.78076 19.4008C10.0624 16.6491 11.5358 14.2549 13.6808 12.7383" stroke="white"
              stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path opacity="0.34"
              d="M14.8726 28.6855C16.1292 29.3247 17.5592 29.6822 19.0651 29.6822C20.5167 29.6822 21.8817 29.3572 23.1059 28.7614"
              stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M19.0649 14.3417C20.7282 14.3417 22.0766 12.9933 22.0766 11.33C22.0766 9.66673 20.7282 8.31836 19.0649 8.31836C17.4016 8.31836 16.0532 9.66673 16.0532 11.33C16.0532 12.9933 17.4016 14.3417 19.0649 14.3417Z"
              fill="white" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M11.2326 27.58C12.8959 27.58 14.2443 26.2316 14.2443 24.5683C14.2443 22.905 12.8959 21.5566 11.2326 21.5566C9.56932 21.5566 8.22095 22.905 8.22095 24.5683C8.22095 26.2316 9.56932 27.58 11.2326 27.58Z"
              fill="white" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M26.7675 27.58C28.4308 27.58 29.7792 26.2316 29.7792 24.5683C29.7792 22.905 28.4308 21.5566 26.7675 21.5566C25.1042 21.5566 23.7559 22.905 23.7559 24.5683C23.7559 26.2316 25.1042 27.58 26.7675 27.58Z"
              fill="white" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          Результаты поиска
        </div>
        <div class="dopFiltres">
          <DopFilter v-for="filter in dopFiltres" :key="filter.id" :options="filter" />
        </div>
        <div class="searchInput" :id="'searchInput'" @mouseover="activeEl('.body')" @mouseleave="removeEl('.body')">
          <input type="text" class="search_Input" placeholder="Введите запрос..." />
          <button class="searchBtn">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20Z"
                stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path opacity="0.4"
                d="M18.9299 20.6888C19.4599 22.2888 20.6699 22.4488 21.5999 21.0488C22.4499 19.7688 21.8899 18.7188 20.3499 18.7188C19.2099 18.7088 18.5699 19.5988 18.9299 20.6888Z"
                stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
        <darkBtn class="darkBtn">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z"
              stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path opacity="0.4" d="M6 8V16" stroke="white" stroke-width="1.5" stroke-miterlimit="10"
              stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9 8V12" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M9 15V16" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M15 8V9" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
              stroke-linejoin="round" />
            <path opacity="0.4" d="M12 8V16" stroke="white" stroke-width="1.5" stroke-miterlimit="10"
              stroke-linecap="round" stroke-linejoin="round" />
            <path d="M15 12V16" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
              stroke-linejoin="round" />
            <path opacity="0.4" d="M18 8V16" stroke="white" stroke-width="1.5" stroke-miterlimit="10"
              stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          Аукционы
        </darkBtn>
      </div>
      <div class="vakansiez">
        <div class="vakansiez__items">
          <MiniCardCompany v-for="item in company.vakancies" :key="item" :company="company" :vakansi="item" />
        </div>
        <div class="registerTo">
          <a  class="btn-all">Показать еще</a>
          <darkBtn :link="'/login'" class="darkBtn">Зарегистрироваться</darkBtn>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 37px;
  margin-bottom: 35px;
}

.headComponent {
  color: #1a1a1a;
  font-family: Aeroport;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  align-items: center;
  gap: 15px;
}

.link {
  color: #1a1a1a;
  text-align: right;
  font-family: Aeroport;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  text-decoration-line: underline;
}

.tabs__vakancies {
  width: 100%;
  margin-bottom: 30px;
}

.tabs__item {
  color: #80879c;
  text-align: center;
  font-family: Aeroport;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: 170px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 25.5px;
  border: 1px solid #d4dbde;
  background: #fff;
  cursor: pointer;
  transition: all 0.3s;
}

.tabs__item.active {
  border: 1px solid #70f;
}

.link__filteres {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}

.kategoryes {
  padding-bottom: 50px;
  border-bottom: 1px solid #b2bec3;
  margin-bottom: 50px;
}

.dopFiltres {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: auto;
}

.searchInput {
  position: relative;
  z-index: 5;
}

.search_Input {
  border-radius: 15px;
  border: 1px solid #e7ecee;
  background: #fff;
  color: #1a1a1a;
  font-family: Aeroport;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  padding: 19px 40px 19px 20px;
  width: 100%;
}

.searchBtn {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  background: none;
  border: none;
}

.vakansiez {
  padding-bottom: 50px;
  border-bottom: 1px solid #b2bec3;
}

.vakansiez__items {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}

.registerTo {
  width: max-content;
  margin: 0 auto;
  margin-top: 50px;
}

.tabs__item {
  margin-right: 38px;
}
.mob.wrap-search-btn {
  display: none;
}
.wrap-swiper-btns .btns {
  display: none;
}

.btn-all {
  display: none;
}

@media (max-width: 1440px) {
  .head {
    flex-wrap: wrap;
  }
}

@media (max-width: 650px) {
  .headComponent {
    font-size: 16px;
    line-height: 21px;
    gap: 10px;
  }

  .headComponent svg {
    width: 32px;
    height: 32px;
  }

  .link {
    font-size: 14px;
    line-height: 19px;
  }

  .head {
    margin-bottom: 25px;
  }

  .head-result {
    display: none;
  }

  .mob.wrap-search-btn {
    display: flex;
    gap: 14px;
    margin-bottom: 21px;
  }

  .searchInput {
    width: 100%;
    flex-shrink: 1;
  }

  .search_Input {
    font-size: 14px;
    padding: 15px 40px 15px 15px;
  }

  .searchBtn {
    right: 15px;
  }

  .searchBtn svg {
    width: 20px;
    height: 20px;
  }

  .mob.wrap-search-btn .darkBtn {
    font-size: 14px;
    line-height: 19px;
    padding: 15px;
    width: 132px;
    height: 50px;
    gap: 14px;
  }

  .mob.wrap-search-btn .darkBtn svg {
    width: 20px;
    height: 20px;
  }
  .wrap-swiper-btns {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 25px;
  }
  .wrap-swiper-btns .btns {
    display: flex;
    gap: 5px;
  }
  .wrap-swiper-btns .btns a {
    width: 36px;
    height: 36px;
    border: 1px solid #D4DBDE;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFF;
  }
  .tabs__vakancies {
    margin-bottom: 0;
  }
  
  .tabs__item {
    width: 142px;
    height: 36px;
    font-size: 14px;
    line-height: 16px;
    padding: 8px 17px;
    margin-right: 10px;
  }
  .kategoryes {
    display: none;
  }
  .vakansiez {
    padding-bottom: 0;
    border-bottom: none;
  }
  .vakansiez__items {
    gap: 15px;
  }
  .btn-all {
    display: inline-block;
    padding: 18px;
    font-family: Aeroport;
    font-size: 16px;
    font-weight: 400;
    line-height: 21.87px;
    text-align: center;
    border: 1px solid #1A1A1A;
    border-radius: 15px;
    color: #1A1A1A;
    background: transparent;
    transition: .3s all;
    max-width: 231px;
    width: 100%;
  }
  .btn-all:hover {
    background: #1A1A1A;
    color: #fff;
  }
  .registerTo {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: auto;
    align-items: center;
    margin-top: 25px;
  }
  .registerTo .darkBtn {
    width: 100%;
    max-width: 231px;
    padding: 18px;
    font-size: 16px;
    line-height: normal;
  }
}
</style>